import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, type ServerView } from "../lib/api";
import { StatusPill } from "../components/StatusPill";
import { money } from "../lib/format";

export function Dashboard() {
  const [servers, setServers] = useState<ServerView[] | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get<{ servers: ServerView[] }>("/servers").then((r) => setServers(r.servers)).catch((e) => setError(e.message));
  }, []);

  return (
    <div className="page">
      <div className="row between">
        <div>
          <h1>Your servers</h1>
          <p className="muted">Manage, monitor and scale your game servers.</p>
        </div>
        <Link to="/games" className="btn btn-primary" data-testid="new-server">+ New server</Link>
      </div>

      {error && <div className="error-box mt">{error}</div>}
      {!servers && <div className="spinner">Loading…</div>}

      {servers && servers.length === 0 && (
        <div className="card mt center" data-testid="empty-state">
          <h3>No servers yet</h3>
          <p className="muted">Deploy your first game server in a couple of minutes.</p>
          <Link to="/games" className="btn btn-primary mt">Browse games</Link>
        </div>
      )}

      {servers && servers.length > 0 && (
        <div className="grid grid-2 mt" data-testid="server-list">
          {servers.map((s) => (
            <Link to={`/dashboard/servers/${s.id}`} className="card" key={s.id} data-testid={`server-card-${s.id}`} style={{ textDecoration: "none", color: "inherit" }}>
              <div className="row between">
                <h3>{s.name}</h3>
                <StatusPill status={s.status} />
              </div>
              <p className="muted">{s.game.name} · {s.plan.name} · {s.region.name}</p>
              {s.connectionAddress ? (
                <div className="row mt"><span className="addr" data-testid="connection-address">{s.connectionAddress}</span></div>
              ) : (
                <p className="muted">{money(s.plan.priceCents)}/mo</p>
              )}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
